import { Component, Input } from '@angular/core';
import { SmartInsightRowVm } from '../../../../domain/model/smart-insights.model';

/** One insight: the tone-tinted icon, headline and sub-line, and the text button to the list or page it names. */
@Component({
  selector: 'ifbp-insight-row',
  templateUrl: './insight-row.component.html',
  styleUrls: ['./insight-row.component.scss'],
  standalone: false,
})
export class InsightRowComponent {
  @Input() vm: SmartInsightRowVm;
}
